import { memo } from 'react';
import {
  Bug,
  Sparkles,
  CheckSquare,
  BookOpen,
  TrendingUp,
  Zap,
  CornerDownRight,
  FileText,
} from 'lucide-react';
import { KanbanCardType, CARD_TYPE_CONFIG } from '../../types/kanban';
import { cn } from '../../utils/cn';

const ICONS: Record<KanbanCardType, React.ComponentType<{ className?: string }>> = {
  bug: Bug,
  feature: Sparkles,
  task: CheckSquare,
  story: BookOpen,
  improvement: TrendingUp,
  epic: Zap,
  subtask: CornerDownRight,
  other: FileText,
};

interface KanbanCardTypeBadgeProps {
  type: KanbanCardType;
  className?: string;
  showLabel?: boolean;
}

export const KanbanCardTypeBadge = memo(
  ({ type, className, showLabel = true }: KanbanCardTypeBadgeProps) => {
    const safeType = type && type in CARD_TYPE_CONFIG ? type : 'other';
    const config = CARD_TYPE_CONFIG[safeType];
    const Icon = ICONS[safeType];
    return (
      <span
        className={cn(
          'badge border',
          className,
        )}
        style={{
          backgroundColor: `${config.color}20`,
          borderColor: `${config.color}40`,
          color: config.color,
        }}
      >
        <Icon className="w-3 h-3" />
        {showLabel && config.label}
      </span>
    );
  },
);
KanbanCardTypeBadge.displayName = 'KanbanCardTypeBadge';
